import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-icon" }

import { ref, watch } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordChangeStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const newPassword = ref("");
const confirmPassword = ref("");
const showNewPassword = ref(false);
const showConfirmPassword = ref(false);
const newPasswordError = ref("");
const confirmPasswordError = ref("");

function getValues() {
  return {
    newPassword: newPassword.value,
    confirmPassword: confirmPassword.value,
  };
}

__expose({ getValues });

watch(() => props.errors, (errs: any) => {
  newPasswordError.value = "";
  confirmPasswordError.value = "";
  if (!errs) return;
  if (errs.password) newPasswordError.value = errs.password;
  if (errs.password_confirmation) confirmPasswordError.value = errs.password_confirmation;
}, { immediate: true });

function validateMatch() {
  confirmPasswordError.value = "";
  if (!confirmPassword.value) return;
  if (confirmPassword.value !== newPassword.value) {
    confirmPasswordError.value = "Passwords do not match.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#e8612f"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("mdi-lock-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "step-content" }, [
        _createElementVNode("h2", { class: "title" }, "Set a new password"),
        _createElementVNode("p", { class: "desc" }, " Create a strong password to keep your account secure. ")
      ], -1))
    ]),
    _createVNode(_component_v_form, { class: "form" }, {
      default: _withCtx(() => [
        _createVNode(AppTextField, {
          modelValue: newPassword.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (newPasswordError.value = ''))
          ],
          type: showNewPassword.value ? 'text' : 'password',
          autocomplete: "new-password",
          label: "New password",
          "label-icon": "mdi-lock-outline",
          "append-inner-icon": showNewPassword.value ? 'mdi-eye-off-outline' : 'mdi-eye-outline',
          placeholder: "Enter new password",
          "error-messages": newPasswordError.value,
          "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (showNewPassword.value = !showNewPassword.value))
        }, null, 8, ["modelValue", "type", "append-inner-icon", "error-messages"]),
        _createVNode(AppTextField, {
          modelValue: confirmPassword.value,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((confirmPassword).value = $event)),
            _cache[4] || (_cache[4] = ($event: any) => (confirmPasswordError.value = ''))
          ],
          type: showConfirmPassword.value ? 'text' : 'password',
          autocomplete: "new-password",
          label: "Confirm new password",
          "label-icon": "mdi-lock-check-outline",
          "append-inner-icon": showConfirmPassword.value ? 'mdi-eye-off-outline' : 'mdi-eye-outline',
          placeholder: "Re-enter new password",
          "error-messages": confirmPasswordError.value,
          onBlur: validateMatch,
          "onClick:appendInner": _cache[5] || (_cache[5] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value))
        }, null, 8, ["modelValue", "type", "append-inner-icon", "error-messages"])
      ]),
      _: 1
    })
  ]))
}
}

})